import React, { useEffect, useState } from "react";
import TopBar from "../../../components/TopBar";
import Header from "../../../components/headerfooter/Header";
import Footer from "../../../components/headerfooter/Footer";
import CallToAction from "../../../components/home/CallToAction";
import Breadcrumb from "../../../components/Breadcrumb";
import MobileFooter from "../../../components/MobileFooter";
import CaptionsSubtitleComp from "../../../components/categoriesall/TextWriting/CaptionsSubtitleComp";
import axios from "axios";
import { IMAGE_URL, REACT_APP_API_PORT, VIDEO_URL } from "../../../Api";
import { Link, useNavigate } from "react-router";
import { FiExternalLink } from "react-icons/fi";
import { BiBookmark, BiBookmarkHeart } from "react-icons/bi";
import Loader from "../../../components/Loader";
import { AiOutlineClose } from "react-icons/ai";
import ReactPlayer from "react-player";
import { getDecryptedData } from "../../../config/crypto";
import { toast } from "react-toastify";
import { motion, AnimatePresence } from "framer-motion";
import { PiSealCheckFill } from "react-icons/pi";
const ToolListBySubCategory = () => {
  const navigate = useNavigate()
  const [data, setData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, settotalItems] = useState(0);
  const [limit, setLimit] = useState(8);
  const [page, setPage] = useState(1);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const getData = async (page) => {
    try {
      let id = localStorage.getItem('FSID')
      setisLoading(true);
      const user = getDecryptedData("user")
      let userId = ""
      if (user) {
        userId = user._id
      }
      const res = await axios.get(`${REACT_APP_API_PORT}user/homepage/tool_list_by_subcategory/${id}?limit=${limit}&page=${page}&userId=${userId}`);
      setisLoading(false);
      if (res.data.status) {
        setData(res.data.data);
        setTotalPages(res.data.pagination?.totalPages); // Assuming API returns total pages
        settotalItems(res.data.pagination?.totalItems); // Assuming API returns total pages
        if (selectedItem) {
          const matchedItem = res.data.data.find(item => item._id === selectedItem._id);
          if (matchedItem) {
            setSelectedItem(matchedItem);
          }
        }
      }

    }
    catch (err) {
      setisLoading(false)
      console.log(err)
    }
  }

  useEffect(() => {
    getData(currentPage);
  }, [currentPage, limit, page]);

  const handleLoadMore = () => {
    setLimit((prevCount) => prevCount + 8);
    // setPage((prevCount) => prevCount + 1);
  };
  // Open Sidebar
  const openSidebar = (item) => {
    setSelectedItem(item);
    setIsSidebarOpen(true);
  };

  // Close Sidebar
  const closeSidebar = () => {
    setIsSidebarOpen(false);
    setSelectedItem(null);
  };
  const [openFaq, setOpenFaq] = useState(null);

  const handleFaqToggle = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index)); // Toggle the FAQ
  };

  const handleToolNavigate = async (toolId) => {
    const user = getDecryptedData("user");
    if (!user) {
      navigate(`/login`)
    }
    if (user) {
      try {
        setisLoading(true)
        const token = getDecryptedData('token')
        const res = await axios.post(`${REACT_APP_API_PORT}user/frontend/save-tool`, {
          tool_id: toolId,
        }, {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
          }
        });
        setisLoading(false)
        if (res.data.status) {
          getData()
        }
      }
      catch (err) {
        setisLoading(false)
        if (err.response.data.status === false) {
          toast.error(err.response.data.message)
        }
      }
    }

  }

  function replaceSpacesWithHyphen(text) {
    return text.replace(/\s+/g, '-');
  }

  return (
    <>
      <Loader isLoading={isLoading} />
      <TopBar />
      <Header />
      <Breadcrumb
        title={data.length > 0 ? data[0].sub_category_id?.sub_category_name : ""}
        breadcrumbs={[
          { label: 'Categories', link: '/ai-tool-categories' },
          { label: data.length > 0 ? data[0].sub_category_id?.sub_category_name : "" },
        ]
        }
        paragraph={`There are ${totalItems} AIs for ${data.length > 0 ? data[0].sub_category_id?.sub_category_name : ""}`}

      />

      <section className="bg-background-back1 overflow-hidden">
        <div className="container max-w-[80rem] mx-auto px-4 pt-5">

          <div className="flex justify-between items-center mt-5 mb-3 w-full">
            <Link to="#">
              <h4 className="font-sans tracking-wide text-lg lg:text-2xl font-bold text-white">

              </h4>
            </Link>

          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {data && data?.slice(0, limit).map((item) => (
              <div
                key={item._id}
                // onClick={() => openSidebar(item)}
                className="cursor-pointer blurBox bg-gray-900 rounded-xl overflow-hidden shadow-lg p-4 transition-transform duration-200"

              >
                <div className="flex items-center gap-2" 
                // onClick={() => openSidebar(item)}
                // onClick={()=>navigate(`/tool-detail/${item?._id}`)}
                onClick={() => {
                    if (item?.tool_name) {
                      navigate(`/tool-detail/${replaceSpacesWithHyphen(item?.tool_name)}/${item?._id}`)
                    }
                    else {
                      navigate(`/tool-detail/${item?._id}`)
                    }
                  }}
                >
                  <div className="relative">
                    <img
                      src={item.logo ? IMAGE_URL + item.logo + "?type=tool" : '/default.jpeg'}
                      // onError={(e)=>e.src.target='/default.jpeg'}
                      onError={(e) => {
                      e.target.onerror = null; // Prevents infinite loop if default image fails
                      e.target.src = '/default.jpeg';
                    }}
                      alt={`${item.tool_name} logo`}
                      className="h-12 w-12 rounded-full"
                    />
                    {
                      (item?.isVerified && item?.isVerified==="Yes") && 
                      <span className="absolute -top-1 -right-1 h-4 w-4 flex items-center justify-center">
                      <PiSealCheckFill className="text-primary h-4 w-4 bg-white rounded-full" />
                      </span>
                    }
                    
                  </div>
                  <div className="flex flex-col truncate">
                    <h5 className="text-lg font-bold text-white truncate">
                      {item.tool_name.length > 20 ? `${item.tool_name.slice(0, 20)}...` : item.tool_name}
                    </h5>
                    <p className="text-sm text-gray-400 truncate">{item?.main_category_id?.category_name}</p>
                  </div>
                </div>
                <div>
                  <p className="text-sm text-gray-400 truncate">{item.description}</p>
                </div>
                <img
                  // onClick={() => openSidebar(item)}
                  // onClick={()=>navigate(`/tool-detail/${item?._id}`)}
                  onClick={() => {
                    if (item?.tool_name) {
                      navigate(`/tool-detail/${replaceSpacesWithHyphen(item?.tool_name)}/${item?._id}`)
                    }
                    else {
                      navigate(`/tool-detail/${item?._id}`)
                    }
                  }}
                  src={item.image ? IMAGE_URL + item?.image + "?type=tool" : '/just-launch-default.png'}
                  // onError={(e)=>e.src.target='/just-launch-default.png'}
                  onError={(e) => {
                      e.target.onerror = null; // Prevents infinite loop if default image fails
                      e.target.src = '/just-launch-default.png';
                    }}
                  alt={item.title}
                  className="w-full mt-3 rounded-lg object-cover h-40 lg:h-40"
                />
                <div className="flex justify-between items-center">
                  <div className="mt-3 flex">
                    <span className="text-sm text-gray-400">{item.payment_type}</span>
                  </div>
                  <div className="flex flex-col mt-2">
                    <div className="flex">
                      <div className="flex flex-row">
                        {/* <Link to="">
                                                    <BiBookmark className="w-5 h-5 text-white" />
                                                </Link> */}
                        <button type="button" onClick={() => handleToolNavigate(item?._id)}>
                          <AnimatePresence mode="wait">
                            {item?.is_saved ? (
                              <motion.div
                                key="saved"
                                initial={{ opacity: 0, scale: 0.5 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.5 }}
                                transition={{ duration: 0.3 }}
                              >
                                <BiBookmarkHeart className="w-5 h-5 text-primary hover:text-white" />
                              </motion.div>
                            ) : (
                              <motion.div
                                key="unsaved"
                                initial={{ opacity: 0, scale: 0.5 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.5 }}
                                transition={{ duration: 0.3 }}
                              >
                                <BiBookmark className="w-5 h-5 text-primary hover:text-white" />
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </button>
                        <Link to={item?.visit_link} target="_blank" className="ml-2">
                          <FiExternalLink className="text-primary w-5 h-5" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {data.length < totalItems && (
            <div className="flex justify-center mt-6">
              <button
                onClick={handleLoadMore}
                className="border-2 border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase"
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </section>
      {/* <CaptionsSubtitleComp /> */}
      {isSidebarOpen && selectedItem && (
        <div className="fixed inset-0 flex items-center justify-end bg-black bg-opacity-70 z-50">
          <div className="bg-background-back2 p-6 rounded-l-lg w-3/4 max-w-lg h-full overflow-y-auto">
            <button className="absolute top-2 right-2 text-white" onClick={closeSidebar}>
              <AiOutlineClose size={20} />
            </button>
            {
              (selectedItem?.video === null && selectedItem?.youtube_link === null) && <>
                <img
                  className="w-full object-cover rounded-lg"
                  style={{ width: "100%", height: "300px" }}
                  src={selectedItem.image ? IMAGE_URL + selectedItem.image : "/favicon.png"}
                  alt={selectedItem.tool_name}
                />
              </>
            }

            {
              (selectedItem?.video_type === 'upload' && selectedItem?.video !== null &&  selectedItem?.video !== "") && <>
                <video style={{ width: "100%", height: "300px" }} controls>
                  <source src={VIDEO_URL + selectedItem?.video + "?type=tool"} type="video/mp4" />
                </video>
              </>
            }

            {/* {
                (selectedItem?.video_type ==='link' && selectedItem?.youtube_link !==null) && <>
                <video width="600" controls>
                  <source src={selectedItem?.youtube_link} type="video/mp4" />
                </video>
                </>
              } */}
            {
              selectedItem?.video_type === "link" && selectedItem?.youtube_link && <>
                <ReactPlayer url={selectedItem?.youtube_link} width="100%" height="300px" controls />
              </>
            }

            <h2 className="text-2xl font-bold text-white mt-4">{selectedItem.tool_name}</h2>
            <p className="text-sm text-gray-400 mt-1">{selectedItem?.main_category_id?.category_name}</p>
            <p className="text-gray-400 mt-2">{selectedItem.description}</p>
            <div
              className="text-sm lg:text-base xl:text-md font-medium text-gray-400 dark:text-white my-3"
              dangerouslySetInnerHTML={{ __html: selectedItem?.details }}
            />
            {/* Key Features Section - Detailed */}
            {/* <div className="mt-6">
                <h3 className="text-lg font-semibold text-white">Key Features:</h3>
                <ul className="list-disc list-inside text-gray-400 mt-2">
                  <li><strong>AI-Powered Content Generation:</strong> Generate high-quality content in seconds using advanced AI algorithms.</li>
                  <li><strong>Pre-built Templates:</strong> Access a variety of pre-built templates for blogs, ads, and social media posts.</li>
                  <li><strong>SEO Optimization Tools:</strong> Built-in tools to help improve search engine rankings and visibility.</li>
                  <li><strong>Multi-language Support:</strong> Supports content generation in multiple languages for a global audience.</li>
                  <li><strong>Content Improvement Suggestions:</strong> Get suggestions on how to enhance the content for better engagement.</li>
                </ul>
              </div> */}

            {/* Benefits Section - Detailed */}
            {/* <div className="mt-6">
                <h3 className="text-lg font-semibold text-white">Benefits:</h3>
                <ul className="list-disc list-inside text-gray-400 mt-2">
                  <li><strong>Increased Productivity:</strong> Save time by creating content 10 times faster than traditional methods.</li>
                  <li><strong>Consistency in Output:</strong> Maintain a steady flow of fresh, high-quality content without the need for constant effort.</li>
                  <li><strong>Engagement:</strong> Craft engaging content that attracts more visitors and boosts conversions.</li>
                  <li><strong>Cost-Effective:</strong> Get professional content without the high costs of hiring a full-time team.</li>
                </ul>
              </div> */}

            {/* Save and Visit Icons */}
            <div className="flex mt-6">
              {/* Save Icon */}
              {/* <Link to="">
                <BiBookmark className="w-6 h-6 text-white hover:text-yellow-400 cursor-pointer" />
              </Link> */}
              <button type="button" onClick={() => handleToolNavigate(selectedItem?._id)}>
                <AnimatePresence mode="wait">
                  {selectedItem?.is_saved ? (
                    <motion.div
                      key="saved"
                      initial={{ opacity: 0, scale: 0.5 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.5 }}
                      transition={{ duration: 0.3 }}
                    >
                      <BiBookmarkHeart className="w-5 h-5 text-green-500 hover:text-white" />
                    </motion.div>
                  ) : (
                    <motion.div
                      key="unsaved"
                      initial={{ opacity: 0, scale: 0.5 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.5 }}
                      transition={{ duration: 0.3 }}
                    >
                      <BiBookmark className="w-5 h-5 text-primary hover:text-white" />
                    </motion.div>
                  )}
                </AnimatePresence>
              </button>
              {/* Visit Link Icon */}
              <Link to={selectedItem?.visit_link} target="_blank" className="ml-4">
                <FiExternalLink className="w-6 h-6 text-white hover:text-yellow-400 cursor-pointer" />
              </Link>
            </div>

            {/* FAQ Section - Dynamic */}
            {
              (selectedItem?.faqs?.length > 0) && <>
                <div className="mt-6" id="Faq">
                  <h3 className="sm:text-base text-sm font-semibold text-white">Faq's</h3>
                  <div className="w-full bg-background-back1 rounded" data-orientation="vertical">
                    {
                      (selectedItem?.faqs?.length > 0) &&
                      selectedItem?.faqs?.map((item, index) => {
                        return <>
                          <div className="px-6 mt-2 rounded-xl bg-foreground">
                            <h3 className="flex">
                              <button
                                type="button"
                                onClick={() => handleFaqToggle(index)}
                                aria-expanded={openFaq === index ? "true" : "false"}
                                className="flex flex-1 items-center justify-between py-4 font-medium transition-all outline-none focus:outline-none border-none lg:text-base text-sm text-left text-white"
                              >
                                {item?.question}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className={`lucide lucide-chevron-down h-4 w-4 shrink-0 transition-transform duration-200 ${openFaq === index ? "rotate-180" : ""}`}
                                >
                                  <path d="m6 9 6 6 6-6"></path>
                                </svg>
                              </button>
                            </h3>

                            <div
                              className={`overflow-hidden text-sm transition-all text-white ${openFaq === index ? "max-h-96" : "max-h-0"}`}
                              style={{
                                transition: "max-height 0.3s ease-out",
                              }}
                            >
                              <p className="mt-2">{item?.answer}</p>
                            </div>
                          </div>
                        </>
                      })
                    }


                    {/* FAQ 2 */}
                    {/* <div className="px-6 mt-2 rounded-xl bg-foreground">
                    <h3 className="flex">
                      <button
                        type="button"
                        onClick={() => handleFaqToggle(1)}
                        aria-expanded={openFaq === 1 ? "true" : "false"}
                        className="flex flex-1 items-center justify-between py-4 font-medium transition-all outline-none focus:outline-none border-none lg:text-base text-sm text-left text-white"
                      >
                        How much does Rare Genie cost?
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className={`lucide lucide-chevron-down h-4 w-4 shrink-0 transition-transform duration-200 ${openFaq === 1 ? "rotate-180" : ""}`}
                        >
                          <path d="m6 9 6 6 6-6"></path>
                        </svg>
                      </button>
                    </h3>
                 
                    <div
                      className={`overflow-hidden text-sm transition-all text-white ${openFaq === 1 ? "max-h-96" : "max-h-0"}`}
                      style={{
                        transition: "max-height 0.3s ease-out",
                      }}
                    >
                      <p className="mt-2">The cost is $19.99 per month.</p>
                    </div>
                  </div> */}
                  </div>
                </div>
              </>
            }
          </div>
        </div>
      )}

      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default ToolListBySubCategory;
